// once we work on the functionality, the selectors will be created here
// sample code

import { createSelector } from 'reselect';
import { welcomeInitState } from './reducer';

const opportunityReducer = (state) => state || welcomeInitState;
const WelcomePage = (state) => state.WelcomePage || welcomeInitState;

const opportunityData = createSelector(opportunityReducer, (cnter) => cnter);
const isOpportunityLoading = createSelector(WelcomePage, (cnter) => cnter.isOpportunityLoading);
const tokenSuccess = createSelector(WelcomePage, (cnter) => cnter.tokenSuccess);
const tokenData = createSelector(WelcomePage, (cnter) => cnter.tokenData);
const stepLabels = createSelector(WelcomePage, (cnter) => cnter.stepLabels);
export default {
	isOpportunityLoading,
	tokenSuccess,
	tokenData,
	opportunityData,
	opportunityReducer,
	stepLabels
};
